import { useMemo } from "react";
import { useLanguage } from "@/context/LanguageContext";

const FAQSection = () => {
  const { copy } = useLanguage();
  const items = copy.faq.items;

  const faqSchema = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      })),
    }),
    [items],
  );

  const faqSchemaJson = useMemo(() => JSON.stringify(faqSchema), [faqSchema]);

  return (
    <section className="section faq-section" data-testid="faq-section">
      <div className="container faq-container" data-testid="faq-container">
        <div className="section-header">
          <p className="section-kicker" data-testid="faq-kicker">
            {copy.faq.kicker}
          </p>
          <h2 className="section-title" data-testid="faq-title">
            {copy.faq.title}
          </h2>
        </div>
        <div className="faq-grid" data-testid="faq-grid">
          {items.map((item, index) => (
            <div className="faq-item" key={item.question} data-testid={`faq-item-${index + 1}`}>
              <h3 data-testid={`faq-question-${index + 1}`}>{item.question}</h3>
              <p data-testid={`faq-answer-${index + 1}`}>{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
      <script type="application/ld+json" data-testid="faq-schema">
        {faqSchemaJson}
      </script>
    </section>
  );
};

export default FAQSection;
